import React from "react";

const LegalHost = () => (
  <section className="w-full bg-light-5 py-8 px-6">
    <h2 className="text-xl font-bold text-dark-1 mb-4">2. Hébergeur</h2>
    <p>
      Le site est hébergé par :<br />
      <strong>[Nom de l’hébergeur]</strong>
    </p>
    <ul className="list-disc list-inside text-light-1 mt-3 space-y-1">
      <li>Adresse : [adresse complète]</li>
      <li>Site web : [url de l’hébergeur]</li>
      <li>Téléphone : [contact hébergeur]</li>
    </ul>
  </section>
);

export default LegalHost;
